// extracted by mini-css-extract-plugin
export var arrows = "_25-6";
export var decrementer = "_25-a";
export var disabled = "_25-4";
export var error = "_25-1";
export var hiddenText = "_25-b";
export var incrementer = "_25-9";
export var input = "_25-8";
export var inputWrapper = "_25-0";
export var leadingIcon = "_25-c";
export var readonly = "_25-3";
export var regular = "_25-7";
export var small = "_25-5";
export var warning = "_25-2";